import React from 'react';

import { Box, Button, Typography, useTheme } from '@mui/material';
import { motion } from 'framer-motion';
import parse from 'html-react-parser';

import useMediaQuery from '@mui/material/useMediaQuery';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import StyledPremiumService from './styles';

const PremiumService = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const isMobile = useMediaQuery(theme.breakpoints.down('lg'));
  const label = t('premium-content');
  const labelmobile = t('premium-content');

  return (
    <StyledPremiumService>
      <Box className="homeBg">
        <Box
          sx={{
            textAlign: { xs: 'center', md: 'center' },
            zIndex: 1,
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(0, 0, 0, 0.5)', // Semi-transparent black overlay
            zIndex: 1,
            padding: '6.5% 10%',
            [theme.breakpoints.down('lg')]: {
              padding: '15% 5% 7% 5%',
            }
          }}
        >
          <Typography
            variant="h2"
            component="h2"
            sx={{
              fontSize: '64px',
              fontWeight: '800',
              lineHeight: '76.38px',
              [theme.breakpoints.down('lg')]: {
                fontSize: '40px',
                fontWeight: 800,
                lineHeight: '47.73px',
                textAlign: 'center',
              },
            }}
          >
            <motion.div
              initial={{
                opacity: 0,
                y: 100,
              }}
              whileInView={{
                opacity: 1,
                y: 0, // Slide in to its original position
                transition: {
                  duration: 1, // Animation duration
                },
              }}
            // viewport={{ once: true }}
            >
              {t('premium-title')}
            </motion.div>
          </Typography>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
              textAlign: 'center',
              mt: 3,
            }}
          >
            <Typography
              variant="body1"
              sx={{
                lineHeight: '23.87px',
                wordWrap: 'break-word',
                fontWeight: localStorage.getItem('i18nextLng') === 'en-US' ? '500' : '700',
                fontSize: '20px',
                mt: 1.5,
                [theme.breakpoints.down('lg')]: {
                  fontSize: '18px',
                  fontWeight: localStorage.getItem('i18nextLng') === 'en-US' ? '500' : '600',
                  lineHeight: '23.4px',
                  textAlign: 'center',
                },
              }}
            >
              <motion.div
                initial={{
                  opacity: 0,
                  y: 100,
                }}
                whileInView={{
                  opacity: 1,
                  y: 0, // Slide in to its original position
                  transition: {
                    duration: 1, // Animation duration
                    delay: 0.8,
                  },
                }}
              // viewport={{ once: true }}
              >
                {!isMobile ? parse(label) : parse(labelmobile)}
              </motion.div>
            </Typography>
          </Box>
          <Box justifyContent={'center'} display={'flex'}>
            <Button
              variant="contained"
              onClick={() => navigate('/contact')}
              sx={{
                color: '#000000',
                backgroundColor: '#0F0',
                borderColor: '#00AA2F',
                borderRadius: '4px',
                width: localStorage.getItem('i18nextLng') === 'en-US' ? '160px' : '120.39px',
                height: '45px',
                // marginRight: '30px',
                marginTop: 5,
                fontSize: '16px',
                fontWeight: 800,
                [theme.breakpoints.down('lg')]: {
                  // width: '100%',
                  fontSize: '18px',
                  lineHeight: '21.48px',
                  // mb: 3
                },
              }}
            >
              {t('premium-button-label')}
            </Button>
          </Box>
        </Box>
      </Box>
    </StyledPremiumService>
  );
};

export default PremiumService;
